// Module
var code = "<select class=\"was-this-useful__no__input was-this-useful__no__reasons\" required ng-options=\"reason.title for reason in $ctrl.reasons\" ng-model=\"$ctrl.selectedReason\" ng-change=\"$ctrl.onReasonChange({ reason: $ctrl.selectedReason })\"> <option value=\"\" system-dictionary=\"WasThisUsefulSelectReason\"></option> </select>";
// Exports
module.exports = code;